import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["programsContainer", "affiliatesContainer"]

  async companyChanged(event) {
    const id = event.target.value
    if (!id) { this.resetAll(); return }
    this.programsContainerTarget.innerHTML  = this.placeholder("Loading…")
    this.affiliatesContainerTarget.innerHTML = this.placeholder("Select a program to load affiliates.")
    this.programsContainerTarget.innerHTML  = await this.fetchFragment(this.programsUrl, { company_id: id })
  }

  async programChanged(event) {
    const id = event.target.value
    if (!id) {
      this.affiliatesContainerTarget.innerHTML = this.placeholder("Select a program to load affiliates.")
      return
    }
    this.affiliatesContainerTarget.innerHTML = this.placeholder("Loading…")
    this.affiliatesContainerTarget.innerHTML = await this.fetchFragment(this.affiliatesUrl, { program_id: id })
  }

  get programsUrl()  { return this.element.dataset.cascadeSelectProgramsUrl }
  get affiliatesUrl() { return this.element.dataset.cascadeSelectAffiliatesUrl }

  async fetchFragment(baseUrl, params) {
    try {
      const url = `${baseUrl}?${new URLSearchParams(params)}`
      const res  = await fetch(url, { headers: { Accept: "text/html" }, credentials: "same-origin" })
      if (!res.ok) return this.placeholder(`Error loading (${res.status}). Refresh and try again.`)
      const text = await res.text()
      const doc  = new DOMParser().parseFromString(text, "text/html")
      const frame = doc.querySelector("turbo-frame")
      return frame ? frame.innerHTML : doc.body.innerHTML
    } catch {
      return this.placeholder("Network error. Refresh and try again.")
    }
  }

  resetAll() {
    this.programsContainerTarget.innerHTML  = this.placeholder("Select a company to see its programs.")
    this.affiliatesContainerTarget.innerHTML = this.placeholder("Select a program to see approved affiliates.")
  }

  placeholder(msg) { return `<p class="gc-placeholder">${msg}</p>` }
}
